import { Country } from "@libs/enums/country.enum.ts";
import {
  greaterThan,
  lessThan,
  predicate,
  required
} from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

import { InvoiceSettingsFormValues } from "../InvoiceSettingsForm.types.tsx";
import { InvoiceSettingsAuBankDetailsValidator } from "./InvoiceSettingsAuBankDetailsValidator.ts";
import { InvoiceSettingsNzBankDetailsValidator } from "./InvoiceSettingsNzBankDetailsValidator.ts";

export class InvoiceSettingsValidator extends Validator<InvoiceSettingsFormValues> {
  constructor(country: Country) {
    super();

    this.forField("gstPercent", [required(), lessThan(100), greaterThan(0)]);

    this.forField("gstNumber", [
      predicate(
        () => country === Country.NewZealand,
        value => {
          if (!value) return undefined;

          const regExp = new RegExp(/\d{2,3}-\d{3}-\d{3}$/);
          return regExp.test(value)
            ? undefined
            : "GST Number must be of the form nnn-nnn-nnn";
        }
      )
    ]);

    this.forField("bankDetails", [
      predicate(
        () => country === Country.Australia,
        value => {
          const accountsValidator = new InvoiceSettingsAuBankDetailsValidator();
          return accountsValidator.validate(value);
        }
      ),
      predicate(
        () => country === Country.NewZealand,
        value => {
          const accountsValidator = new InvoiceSettingsNzBankDetailsValidator();
          return accountsValidator.validate(value);
        }
      )
    ]);
  }
}
